/**
 * Feature IDs enum for subscription features
 *
 * This enum centralizes all feature ID mappings used throughout the application.
 * Update this file when feature IDs change to ensure consistency across the codebase.
 *
 * Usage:
 *   import { FeatureIds } from "@root/utils/featureIds";
 *   if (feature.id === FeatureIds.OrganizationAsVendorOrVenue) { ... }
 */
export enum FeatureIds {
  EventLength = 1,
  ExportEventsToFacebookAndLinkedIn = 3,
  CustomizePinColors = 4,
  OrganizationAsVendorOrVenue = 5,
  RecurringEvent = 6,
  ExternalTicketingLinksOnEvents = 7,
  EventLeadTime = 8,
  CustomPinIcons = 9,
  // Ticketing transfer settings (stored as plan features with numeric/string values)
  TransferDelayDays = 10,
  TransferValue = 11,
  TransferMode = 12,
}

export function hasStripePayoutFeatures(features: { id: number }[]): boolean {
  const ids = new Set(features.map((f) => f.id));
  return [FeatureIds.TransferMode, FeatureIds.TransferValue, FeatureIds.TransferDelayDays].every(
    (id) => ids.has(id),
  );
}
